import { IS_PROD_ENV } from '@/lib/env';

export type Tier = 'bronze' | 'silver' | 'gold' | 'platinum';

export const TIER_THRESHOLDS = {
  silver: IS_PROD_ENV ? 500 : 5,
  gold: IS_PROD_ENV ? 2000 : 15,
  platinum: IS_PROD_ENV ? 5000 : 30,
} as const;

export function getTier(points: number): Tier {
  if (points >= TIER_THRESHOLDS.platinum) return 'platinum';
  if (points >= TIER_THRESHOLDS.gold) return 'gold';
  if (points >= TIER_THRESHOLDS.silver) return 'silver';
  return 'bronze';
}

export const TIER_HEX: Record<Tier, string> = {
  bronze: '#A0522D',
  silver: '#9E9E9E',
  gold: '#D4AF37',
  platinum: '#A5A9B4',
};
